import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth, ensureUserRole } from './firebase';
import EventSubmission from './EventSubmission';
import GroupEventDashboard from './GroupEventDashboard';
import CreateGroupEvent from './CreateGroupEvent';
import GroupEventAdmin from './GroupEventAdmin';
import SuperAdminSetup from './SuperAdminSetup';
import LandingPage from './LandingPage';
import SettlementHub from './SettlementHub';
import Disclaimer from './Disclaimer';
import PrivacyPolicy from './PrivacyPolicy';
import './App.css';

// ── Admin shell — any signed-in user gets access ──────────────────────────────

function AdminShell() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState<string>('user');

  useEffect(() => {
    return onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        const r = await ensureUserRole(u);
        setRole(r);
      }
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="App">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
          <div className="es-spinner" />
        </div>
      </div>
    );
  }

  if (!user) return <LandingPage onSignIn={() => {}} error="" />;

  return (
    <Routes>
      <Route path="/create" element={<CreateGroupEvent user={user} />} />
      <Route path="/*" element={<GroupEventDashboard user={user} role={role} />} />
    </Routes>
  );
}

// ── Root ──────────────────────────────────────────────────────────────────────

function App() {
  return (
    <Routes>
      {/* Public: anonymous member submission */}
      <Route path="/event/:eventCode" element={<EventSubmission />} />

      {/* Public: live settlement hub */}
      <Route path="/event/:eventCode/settle" element={<SettlementHub />} />

      {/* Admin event detail (auth handled inside) */}
      <Route path="/admin/event/:eventCode" element={<GroupEventAdmin />} />

      {/* Legal */}
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />

      {/* Super admin setup (secret URL, email-gated) */}
      <Route path="/super-admin-setup" element={<SuperAdminSetup />} />

      {/* All other admin routes */}
      <Route path="/*" element={<AdminShell />} />
    </Routes>
  );
}

export default App;
